import React, { useState, useEffect } from 'react'
import { getBreadcrum } from 'helpers/util-common'
import { Link } from 'react-router-dom'

const RenderBreadcrumb = () => {

	const [urlList, setUrl] = useState([])

	useEffect(() => {
		setUrl(getBreadcrum())
	})

	return (
		<nav aria-label="breadcrumb" data-testid="atom-component">
			<ol className="breadcrumb astm-breadcrumb">
				{urlList && urlList.length > 0 &&
					urlList.map((urlItem, index) => <li key={index} data-testid="no-link-2" className="breadcrumb-item">
						{urlItem.url ? urlItem.url.includes('MyASTM')?<a href={`${process.env.REACT_APP_MEETING_APP_URL.replace('meeting','')+urlItem.url}`}>{urlItem.title}</a> : <Link to={urlItem.url}>{urlItem.title}</Link> : urlItem.title}</li>)}

			</ol>
		</nav>
	)
}

export default RenderBreadcrumb
